import { useCallback, useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { ADMIN_INVOICES_API_PATHS } from '../constants/invoices-app-paths.constant';
import { Invoice } from '../types/invoice.type';
import { InvoiceStatus } from '../types/invoice-status.type';

export function useUpdateInvoiceStatus() {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);

  const updateStatus = useCallback(
    async (invoiceId: string, status: InvoiceStatus): Promise<Invoice | null> => {
      setIsLoading(true);
      try {
        const url = ADMIN_INVOICES_API_PATHS.UPDATE_INVOICE_STATUS(invoiceId);
        const response = await HttpClient.patch<Invoice>(url, { status });
        enqueueSnackbar('Statut mis à jour', { variant: 'success' });
        return response;
      } catch (error) {
        enqueueSnackbar(
          extractApiErrorMessage(error, 'Erreur lors de la mise à jour du statut'),
          { variant: 'error' },
        );
        return null;
      } finally {
        setIsLoading(false);
      }
    },
    [enqueueSnackbar],
  );

  return { updateStatus, isLoading };
}
